/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Foxit_BestInputs */

const en_pc_alt_t_foxit_best = /** @type {(inputs: Pc_Alt_T_Foxit_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full PDF editing and conversion`)
};

const zh_pc_alt_t_foxit_best = /** @type {(inputs: Pc_Alt_T_Foxit_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完整的 PDF 编辑与转换`)
};

/**
* | output |
* | --- |
* | "Full PDF editing and conversion" |
*
* @param {Pc_Alt_T_Foxit_BestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_foxit_best = /** @type {((inputs?: Pc_Alt_T_Foxit_BestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Foxit_BestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_foxit_best(inputs)
	return zh_pc_alt_t_foxit_best(inputs)
});
export { pc_alt_t_foxit_best as "pc.alt.t.foxit.best" }